import { GetLookUps } from '../../utils/axios/LookUpAPI';
import { GetRole } from '../../utils/axios/UserApi';

export const ROLE = {
    COLLEGE: '',
    GROK_ADMIN: '',
    COMPANY: '',
    STUDENT: '',
    EXTERNAL_USER: '',

};

export const ORGANIZATION_TYPE = {
    //Type 5
    COLLEGE: '',
    COMPANY: '',
}

export const IS_GROVATOR = {
    //Type 9
    ASSOCIATED: '',
    NON_ASSOCIATED: '',  
}

// Constants for lookup names to avoid hardcoding strings
const LOOKUP_NAMES = {
    INDUSTRY_PARTNER: 'Industry Partner',
    ASSOCIATE_COLLEGE: 'Associate College',
    GROVATOR: 'Grovator',
    NONGROVATOR: 'NonGrovator',
    COLLEGE: 'College',
    COMPANY: 'Company',
    GROK_ADMIN: 'Grok Admin',
    STUDENT: 'Student',
    EXTERNAL_USER: 'External User',
  };
  
  export async function FetchLookups() {
    // Payloads for API calls
    const OrganisationTypePayload = { Type: 5 };
    const isGrovatorTypePayload = { Type: 9 };
  
    // Make API calls concurrently using Promise.all
    const [orgTypeResponse, isGrovatorResponse, roleResponse] = await Promise.all([
      GetLookUps(OrganisationTypePayload),
      GetLookUps(isGrovatorTypePayload),
      GetRole(),
    ]);
  
    // Optional: Create lookup maps for more efficient lookups (if needed)
    const orgTypeMap = createLookupMap(orgTypeResponse.data);
    const isGrovatorMap = createLookupMap(isGrovatorResponse.data);
    const roleMap = createLookupMap(roleResponse.data);
  
    // Assign values using the maps (or keep using .find if the map isn't beneficial)
    ORGANIZATION_TYPE.COMPANY = orgTypeMap[LOOKUP_NAMES.INDUSTRY_PARTNER]; // or orgTypeResponse.data.find(...)
    ORGANIZATION_TYPE.COLLEGE = orgTypeMap[LOOKUP_NAMES.ASSOCIATE_COLLEGE]; // or orgTypeResponse.data.find(...)
  
    IS_GROVATOR.ASSOCIATED = isGrovatorMap[LOOKUP_NAMES.GROVATOR]; // or isGrovatorResponse.data.find(...)
    IS_GROVATOR.NON_ASSOCIATED = isGrovatorMap[LOOKUP_NAMES.NONGROVATOR]; // or isGrovatorResponse.data.find(...)
  
    ROLE.COLLEGE = roleMap[LOOKUP_NAMES.COLLEGE]; // or roleResponse.data.find(...)
    ROLE.COMPANY = roleMap[LOOKUP_NAMES.COMPANY]; // or roleResponse.data.find(...)
    ROLE.GROK_ADMIN = roleMap[LOOKUP_NAMES.GROK_ADMIN]; // or roleResponse.data.find(...)
    ROLE.STUDENT = roleMap[LOOKUP_NAMES.STUDENT]; // or roleResponse.data.find(...)
    ROLE.EXTERNAL_USER = roleMap[LOOKUP_NAMES.EXTERNAL_USER]; // or roleResponse.data.find(...)
  }
  
  // Helper function to create a lookup map (optional)
  function createLookupMap(data) {
    const map = {};
    if (Array.isArray(data)) {
        data.forEach(item => {
          map[item.Name] = item._id;
        });
    }
    return map;
  }
